import { Component, Input } from '@angular/core';

@Component({
  selector: 'atom-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent {
  @Input() href: string = '#';  // URL de destino del enlace
  @Input() label: string = '';  // Texto del enlace
}
